export { default } from './WindIndicator';
